// Update contents object below

const contents = {
  header: 'Amazon Web Services + Intel',
  logoTooltip: {
    href: '',
    copy: ''
  },
  hero: {
    background: 'image',
    title: 'Cloud Innovation for Virtually Every Application',
    copy:
      'Advances in cloud technology are helping organizations of all sizes reinvent their industries – from large global enterprises to government agencies, to pioneering start-ups.',
    copy2:
      'Explore how customers are using the AWS cloud with Intel technologies to power a broad range of applications to help optimize food supply chains, transform capital markets, discover soccer talent around the world, change the face of moviemaking, and save endangered species.'
  },
  sectionContents: [
    {
      id: 'aiscout',
      title: 'Discovering Diverse Talent with AiSCOUT',
      content: 'video1',
      copy:
        'AiSCOUT discovers soccer talent anywhere in the world using artificial intelligence and motion-tracking technology powered by AWS and Intel.',
      url: 'https://sponsorcontent.cnn.com/interactive/aws-intel/2022/aiscout/',
      button: 'Watch Video',
      backgroundType: 'video',
      backgroundVid:
        'https://courageous-cdn-media-bucket.s3.amazonaws.com/AWS/awsHubReinventBG.mp4',
      backgroundVidM:
        'https://courageous-cdn-media-bucket.s3.amazonaws.com/AWS/awsHubReinventBGM.mp4'
    },
    {
      id: 'reinventingInfra',
      title: 'Improving the Human Experience with Technology',
      content: 'article1',
      copy:
        'Find out how innovative organizations are using the power and potential of the AWS cloud   with Intel technologies to drive progress that improves the human experience.',
      url: 'https://sponsorcontent.cnn.com/interactive/aws-intel/reinventing-infrastructure/',
      button: 'Read Article',
      backgroundType: 'image'
    },
    {
      id: 'peak',
      title: 'Fighting Hunger in the UK with AI',
      content: 'article2',
      copy:
        'The AWS cloud with Intel technologies is helping FareShare manage their food supply chain to provide millions of meals to vulnerable people.',
      url: 'https://sponsorcontent.cnn.com/interactive/aws-intel/peak-fareshare/',
      url2: 'https://sponsorcontent.cnn.com/interactive/aws-intel/2022/peak-fareshare/',
      button: 'Read Article',
      button2: 'Watch Video',
      backgroundType: 'video',
      backgroundVid: 'https://courageous-cdn-media-bucket.s3.amazonaws.com/AWS/awsHubPeakbg.mp4',
      backgroundVidM: 'https://courageous-cdn-media-bucket.s3.amazonaws.com/AWS/awsHubPeakbgM.mp4'
    },
    {
      id: 'comp3',
      title: 'Changing the Face of Moviemaking',
      content: 'article3',
      copy:
        'By lifting video postproduction into the AWS cloud, Company 3 strengthened global collaboration and increased its workflow efficiency—all of which allowed its artists to be even more creative with their moviemaking magic.',
      url: 'https://sponsorcontent.cnn.com/interactive/aws-intel/company-3/',
      button: 'Read Article'
    },
    {
      id: 'ronin',
      title: 'Cloud Technology Helps Scientists Move Faster to Save Endangered Species',
      content: 'article4',
      copy:
        'The AWS cloud and Intel technology give Australian researchers the power and flexibility they need to build a digitized genomic library in order to safeguard the genetic diversity of species threatened by habitat loss, wildfires, and climate change.',
      url: 'https://sponsorcontent.cnn.com/interactive/aws-intel/ronin/',
      button: 'Read Article',
      backgroundType: 'video',
      backgroundVid: 'https://courageous-cdn-media-bucket.s3.amazonaws.com/AWS/roninHero.mp4',
      backgroundVidM: 'https://courageous-cdn-media-bucket.s3.amazonaws.com/AWS/roninHero.mp4'
    }
  ]
};

export default contents;
